'use strict';

module.exports = require('./_reduce')(function (a, b) { return a + b; }, 0);
